import { format } from "date-fns/esm";

import { unixTimestampToMs } from "utils/time";

const formatChangeHistoryCardEntryTime = (timestamp: number): string => {
  return format(unixTimestampToMs(timestamp), "h:mm:ss a");
};

export default formatChangeHistoryCardEntryTime;
